// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3vF1e","boxTitle":"Qualiphy_boxTitle__1Zh6Z","box":"Qualiphy_box__1quFM","toggleWrap":"Qualiphy_toggleWrap__SH2sw"};